import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { ourTeamPageData } from "../../common";
import { Container } from "reactstrap";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
// import ellipseImageTop from '../../assets/images/landingpage/Ellipse1880.avif'
// import ellipseImageBottom from '../../assets/images/landingpage/Ellipse1879.avif'
// import { getIPGeoLocation } from "../../common/GeneralUtils";
import { Link } from "react-router-dom";
import axios from "axios";
import * as Icons from '../../common/icons/ourTeamPageDataIcons';
// import Toasts from "../../components/Toasts/Toasts";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const YourIdea = Loadable(
//     lazy(() => import('../../components/AboutUs/YourIdea'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const OurLatestBlogs = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/OurLatestBlogs'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const ellipseImageTop = Loadable(
//     lazy(() => import('../../assets/images/landingpage/Ellipse1880.avif'))
// )
// const ellipseImageBottom = Loadable(
//     lazy(() => import('../../assets/images/landingpage/Ellipse1879.avif'))
// )


const LifeAtVarahiSoft = () => {
    // const location = useLocation();
    // const [toasts, setToasts] = useState(null)
    const [ourTeamPageData, setData] = useState({});

    const getAllOurTeamPageData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/lifeAtVarahisoftPageData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    useEffect(() => {
        getAllOurTeamPageData()
        // getIPGeoLocation(location.pathname)
    }, [])
    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper ourTeam-page-wrapper">
                <div className="container-fluid">
                    <div className="page-content-top">
                        <AboutUsBanner bannerImg={ourTeamPageData?.bannerImg} data={ourTeamPageData?.headerData} />
                        <Container>
                            <div className="team-culture-screen">
                                <h2>{ourTeamPageData?.teamCulture?.title}</h2>
                                <p>{ourTeamPageData?.teamCulture?.text}</p>
                                <div className="team-culture-gallery">
                                    {ourTeamPageData?.teamCulture?.images?.map((img, index) => (
                                        <div className="gallery-item" key={index}>
                                            <LazyLoadImage
                                                src={img?.image}
                                                alt=""
                                                effect="blur"
                                                wrapperClassName="gallery-img-wrapper"
                                            />
                                            {/* <LazyLoadImage
                                                src={img?.image}
                                                alt={`team-${img?.id}`}
                                                effect="blur"
                                            /> */}
                                        </div>
                                    ))}
                                </div>
                                {/* <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 py-5">
                                    {ourTeamPageData?.teamCulture?.images.map((img, index) => <div key={index} className="my-gallery">
                                        <LazyLoadImage
                                            className="img-fluid w-100"
                                            alt={`img${img?.id}`}
                                            // height={image.height}
                                            src={img?.image} // use normal <img> attributes as props
                                        // width={image.width}
                                        />
                                    </div>)}
                                </div> */}
                                <div className="m-auto text-center">
                                    <h3>
                                        {ourTeamPageData?.teamCulture?.follow?.title}
                                    </h3>
                                    <div className="d-flex no-block align-items-center justify-content-center gap-2">
                                        {ourTeamPageData?.teamCulture?.follow?.icons?.map((icon, index) => {
                                            const FollowIcon = Icons[icon?.icon] || null;
                                            return (<Link key={index} className="d-flex no-block align-items-center justify-content-center icon-div" to={icon?.link} target='_blank' >
                                                {FollowIcon && <FollowIcon />}
                                            </Link>)
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
            <Footer />
            {/* {toasts && <Toasts toastsList={toasts} />} */}
        </div>
    );
}

LifeAtVarahiSoft.propTypes = {
    classes: PropTypes.object
};

export default LifeAtVarahiSoft;
